import { createApp } from "vue";
import { store, key } from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
  faArrowAltCircleRight,
  faArrowDown,
  faArrowUp,
  faBackward,
  faBars,
  faBold,
  faCog,
  faCopy,
  faFastBackward,
  faFile,
  faFillDrip,
  faFont,
  faItalic,
  faLock,
  faLockOpen,
  faPaste,
  faRedo,
  faUnderline,
  faUndo,
  faQuestionCircle,
  faSave,
  faMobile,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

import App from "./App.vue";

require("@/canvas-api/FabricOverride");
require("@/canvas-api/LoadFonts");

library.add(
  faFastBackward,
  faBackward,
  faArrowAltCircleRight,
  faFont,
  faCog,
  faBold,
  faItalic,
  faUnderline,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faCopy,
  faPaste,
  faArrowUp,
  faArrowDown,
  faBars,
  faUndo,
  faRedo,
  faFillDrip,
  faFile,
  faLock,
  faLockOpen,
  faQuestionCircle,
  faSave,
  faMobile,
  faDownload
);

createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(store, key)
  .mount("#app");
